import { useCallback, useEffect, useState } from 'react'

import { useAppStore } from '@/context/useAppStore'
import { useConnectionQualityStore } from '@/context/useConnectionQualityStore'
import { apiClient } from '@/services/axios'

const PROBE_MS = 5000

const NetworkStatus = () => {
  const [, setIsOnline] = useState(navigator.onLine)
  const { setAppStore } = useAppStore()
  const isPoorConnection = useConnectionQualityStore((s) => s.isPoor)

  const updateOnlineStatus = useCallback(() => {
    setIsOnline(navigator.onLine)
    if (navigator.onLine) {
      window.location.replace('/tickets')
    } else {
      setAppStore({
        errors: { network: true, server: false },
      })
    }
  }, [setAppStore])

  useEffect(() => {
    window.addEventListener('online', updateOnlineStatus)
    window.addEventListener('offline', updateOnlineStatus)

    return () => {
      window.removeEventListener('online', updateOnlineStatus)
      window.removeEventListener('offline', updateOnlineStatus)
    }
  }, [updateOnlineStatus])

  // apiClient times these; without them recovery waits on page traffic
  useEffect(() => {
    if (!isPoorConnection) return

    let inFlight = false
    const id = setInterval(() => {
      if (inFlight || document.hidden) return
      inFlight = true
      apiClient
        .get('health/', { timeout: PROBE_MS })
        .catch(() => {})
        .finally(() => {
          inFlight = false
        })
    }, PROBE_MS)

    return () => clearInterval(id)
  }, [isPoorConnection])

  return null
}

export default NetworkStatus
